/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.css';
import './style.css';

/**
 * Internal dependencies
 */
import metadata from './block.json';
import deprecated from './deprecated';
import Edit from './edit';
import save from './save';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
  edit: Edit,
  save,
  deprecated,
  isValid( content, blockContent ) {
    // Decode HTML
    const decode = ( str ) => {
      const txt = document.createElement( 'textarea' );
      txt.innerHTML = str;
      return txt.value;
    };
    // Compare content from saved block to blockContent generated by save function
    return decode( content ) === decode( blockContent );
  }
});
